import ContainerList from '@/features/common/components/Overview/parts/ProductItem/parts/ContainerList'
import OptionRow from '@/features/common/components/Overview/parts/ProductItem/parts/OptionRow'
import styles from '@/features/common/components/Overview/parts/ProductItem/styles'
import {
    ProductItem,
    TextSize,
} from '@/features/common/components/Overview/parts/ProductItem/types'
import { FC } from 'react'
import { View } from 'react-native'

interface OptionListProps {
    addons?: ProductItem['addons']
    removedIngredients?: ProductItem['removedIngredients']
    containers?: ProductItem['containers']
    textSize: TextSize
}

const OptionList: FC<OptionListProps> = ({ addons, removedIngredients, containers, textSize }) => {
    if (!addons?.length && !removedIngredients?.length && !containers?.length) return null

    return (
        <View style={styles.optionsContainer}>
            {addons?.map((item) => (
                <OptionRow
                    key={item.id}
                    icon="plus"
                    name={item.name}
                    price={item.price}
                    textSize={textSize}
                />
            ))}
            {removedIngredients?.map((item) => (
                <OptionRow key={item.id} icon="minus" name={item.name} textSize={textSize} />
            ))}
            {!!containers?.length && <ContainerList containers={containers} textSize={textSize} />}
        </View>
    )
}

export default OptionList
